// removed by extract-text-webpack-plugin
module.exports = {"textBox":"_3ua1eodsS4ZftWp6NwUV53"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/componentStyle/textBox/textBox.scss
// module id = 13807
// module chunks = 0